import logSystemUtil from '../../../logs/redux/actions/log'
import REDUX_DOMAIN from '../../../redux/constants/domain'
import { REDUX_DOMAIN_LIST_KEY } from '../../../redux/constants/key'
import REDUX_OPTION from '../../../redux/constants/option'
import { REDUX_DOMAIN_TO_SORT_ORDER, REDUX_SHOULD_SORT } from '../../../redux/constants/should-sort'
import createDomainListReduxUtil from '../../../redux/utils/create-domain-list'
import getClassNameReduxUtil from '../../../redux/utils/get-class-name'
import { getDataPathReduxUtil } from '../../../redux/utils/get-data-path'
import { getIdReduxUtil } from '../../../redux/utils/get-id'
import getInstancesFromMapReduxUtil from '../../../redux/utils/get-instances-from-map'
import getSortKeysReduxUtil from '../../../redux/utils/get-sort-key'
import isNewReduxUtil from '../../../redux/utils/is-new'
import isTemporaryIdReduxUtil from '../../../redux/utils/is-temporary-id'
import addReferenceUtil from '../../../references/utils/add'
import shuffleArrayUtil from '../../../../utils/array/shuffle'

import getSortOrderReduxUtil from '../../../redux/utils/get-sort-order'
import getSortedInstancesReduxUtil from '../../../redux/utils/add-instance-to-domain-list/get-sorted-instances'
import setUtil from '../../../../utils/set'
import { getObjectUtil, uniqArrayUtil } from 'packages/src'

/**
 * Adds an instance to the DomainList(s).
 * NOTE: If the DomainList key is `all`, the instance will also be added to
 * the sectioned DomainLists.
 * e.g. `state.articles.${category}` => `state.articles.nutrition`
 * @param   {Object} params
 *          {Object} state
 *          {Instance} instance
 *          {string} domainListPath
 *          {Object} options
 * @returns {Object}
 */
export default function addInstanceToDomainListReduxUtil (params) {
  const {
    state,
    instance,
    domainListPath,
    existingInstance,
    options
  } = params

  const className = getClassNameReduxUtil(instance)
  const id = getIdReduxUtil(instance)
  const logPrefix = `className=${className} id=${id} domainListPath=${domainListPath}`
  logSystemUtil('addInstanceToDomainListReduxUtil').debug(`${logPrefix}`)

  if (!domainListPath) {
    logSystemUtil('addInstanceToDomainListReduxUtil').warn('domainListPath not provided, instance=', instance)
    return state
  }

  const domainListDataPath = getDataPathReduxUtil(domainListPath)
  // Get the DomainList
  const domainList = (
    getObjectUtil(state, domainListPath || 'all') ||
    createDomainListReduxUtil()
  )
  const domainListData = getObjectUtil(state, domainListDataPath) || []

  // Set the sorted instance
  const domainPath = REDUX_DOMAIN[getClassNameReduxUtil(instance)]
  const domain = getObjectUtil(state, domainPath)
  if (!domain) {
    logSystemUtil('addInstanceToDomainListReduxUtil').warn(`domain not found with domainPath=${domainPath} domainListPath=${domainListPath} and instance=`, instance)
    return state
  }
  const currentInstances = getInstancesFromMapReduxUtil(domain.data, domainListData)

  const instances = [
    ...currentInstances,
    instance
  ]

  const propsToPass = { domainPath, domainListPath }
  const sortKeys = getSortKeysReduxUtil(propsToPass)
  const sortOrder = getSortOrderReduxUtil(propsToPass) || REDUX_DOMAIN_TO_SORT_ORDER[domainPath]
  const shouldSort = REDUX_SHOULD_SORT[domainPath] ?? true
  const shouldShuffle = options?.[REDUX_OPTION.SHUFFLE_DOMAIN_LIST_DATA_ORDER]

  let newInstances
  if (shouldSort && !shouldShuffle) {
    newInstances = getSortedInstancesReduxUtil({ instances, sortKeys, sortOrder })
  } else {
    newInstances = instances
  }

  // Get the instance keys
  let newDomainListData = newInstances.map(getIdReduxUtil)
  if (existingInstance && isNewReduxUtil(existingInstance)) {
    const existingId = getIdReduxUtil(existingInstance)
    logSystemUtil('addInstanceToDomainListReduxUtil').debug(`${logPrefix} filter existingId=${existingId}`)
    newDomainListData = newDomainListData.filter(id => (id !== existingId))
  }

  // Add the instance to the DomainList
  newDomainListData = uniqArrayUtil(newDomainListData)
  if (shouldShuffle) {
    newDomainListData = shuffleArrayUtil(newDomainListData)
  }
  let newDomainList = setUtil(domainList, REDUX_DOMAIN_LIST_KEY.DATA, newDomainListData)

  const lastId = newDomainListData[newDomainListData.length - 1]
  if (lastId && !isTemporaryIdReduxUtil(lastId)) {
    newDomainList = setUtil(
      newDomainList,
      REDUX_DOMAIN_LIST_KEY.LAST_ID,
      lastId
    )
  }

  // Update the DomainList
  const newState = setUtil(state, domainListPath, newDomainList)

  const addReferenceObj = addReferenceUtil({
    instance,
    referencePath: getDataPathReduxUtil(domainListPath),
    state: newState
  })

  if (!addReferenceObj) {
    return newState
  }
  return addReferenceObj.state
}
